import createAboPaths from './abo-paths';

/**
 * BasketOnsite component class
 */
class BasketOnsite
{
    /**
	 * BasketOnsite constructor
	 */
    constructor()
    {
        // elements
        this.element = document.querySelector('.js-basket-onsite');
        this.basketItemListElement = document.querySelector('.js-basket-onsite__basket-item-list');
        this.basketEmptyElement = document.querySelector('.js-basket-onsite__basket-empty');
        this.loadingIndicatorElement = null;

        // api
        this.api = orion.api.cart;

        // i18n
        this.quantityText = '';
        this.quantityPrefixText = '';

        // options
        this.options = {
            productCount: 10,
            sortField: 'timeUpdated',
            sortDirection: 'desc',
            loadingIndicatorHiddenClass: 'loading-indicator--hidden'
        };
    }

    /**
	 * Init BasketOnsite component
	 */
    init()
    {
        if (this.element === null)
        {
            return;
        }

        this.loadingIndicatorElement = this.initLoadingIndicator();

        this.initEvents();
        this.update();

        this.quantityText = this.fetchQuantityText();
        this.quantityPrefixText = this.fetchQuantityPrefixText();
    }

    initLoadingIndicator()
    {
        return this.element.querySelector('.loading-indicator');
    }

    /**
	 * Init Events
	 */
    initEvents()
    {
        // listen to cart update events fired by e. g. 'Add to shopping cart' buttons
        $('body')
            .on(orion.constants.EventCartProductCreated, this.update.bind(this))
            .on(orion.constants.EventCartProductUpdated, this.update.bind(this))
            .on(orion.constants.EventCartProductDeleted, this.update.bind(this));
    }

    /**
	 * Updates the cart by fetching 10 cart items ordered descending by 'timeUpdated'.
	 * If there are no items in the cart, then the 'cart empty' element gets visible.
	 * Otherwise the item list is built and appended to the cart item list wrapper.
	 */
    update()
    {
        this.loadingIndicatorElement.classList.remove(this.options.loadingIndicatorHiddenClass);

        this.api.readItems(
            0,
            this.options.productCount,
            this.options.sortField,
            this.options.sortDirection
        ).done((data) =>
        {
            let basketItems = data.response.productItems;

            // remove all items
            this.basketItemListElement.innerHTML = '';

            if (basketItems.length)
            {
                this.basketItemListElement.classList.remove('hidden');
                this.basketEmptyElement.classList.add('hidden');

                basketItems.forEach((basketItem) =>
                {
                    if (basketItem.productUnknown === false)
                    {
                        let basketItemElement = this.createBasketItemElement(basketItem);

                        this.basketItemListElement.append(basketItemElement);
                    }
                });
            }
            else
            {
                this.basketEmptyElement.classList.remove('hidden');
                this.basketItemListElement.classList.add('hidden');
            }

            this.loadingIndicatorElement.classList.add(this.options.loadingIndicatorHiddenClass);
        });
    }

    /**
	 * @returns {string}
	 */
    fetchQuantityText()
    {
        let text = this.element.dataset.basketOnsiteTextQuantity;

        return typeof text !== 'undefined' ? text : '';
    }

    /**
	 * @returns {string}
	 */
    fetchQuantityPrefixText()
    {
        let text = this.element.dataset.basketOnsiteTextQuantityPrefix;

        return typeof text !== 'undefined' ? text : '';
    }

    /**
	 * Generates one item of the item list.
	 * @param basketItem {Object}
	 * @returns {HTMLLIElement}
	 */
    createBasketItemElement(basketItem)
    {
        let li = document.createElement('li');
        li.classList.add('js-basket-onsite__basket-item-list__item', 'basket-onsite__basket-item-list__item');

        let productImageElement = this.createProductImageElement(basketItem.productImageUrl);

        let productAttributesElement = this.createProductAttributesElement(
            basketItem.productName,
            basketItem.productNumber,
            basketItem.productVariation,
            basketItem.quantity,
            basketItem.discountedPrice
        );

        let productSubTotalElement = this.createSubTotalElement(basketItem.subtotalPrice);

        li.append(productImageElement);
        li.append(productAttributesElement);
        li.append(productSubTotalElement);

        return li;
    }

    /**
	 * Generates the product image part of the item list:
	 * <div>
	 *     <img src="/assets/product-images/grosso/product-main-image/24931521001_verp.jpg">
	 * </div>
	 * @param src {string}
	 * @returns {HTMLDivElement}
	 */
    createProductImageElement(src)
    {
        const div = document.createElement('div');
        const picture = document.createElement('picture');
        const sourceAvif = document.createElement('source');
        const sourceWebp = document.createElement('source');
        const sourceJpeg = document.createElement('source');
        const img = document.createElement('img');

        const originalSrc = src.replace('product-main-image', 'product-list-image');

        const aboPaths = createAboPaths(originalSrc);

        sourceAvif.setAttribute('type', 'image/avif');
        sourceWebp.setAttribute('type', 'image/webp');
        sourceJpeg.setAttribute('type', 'image/jpeg');

        if (aboPaths.original.indexOf('/product-zoom-image') === -1)
        {
            sourceAvif.setAttribute('srcset', aboPaths.avifImage + ', ' + aboPaths.avifRetinaImage + ' 2x');
            sourceWebp.setAttribute('srcset', aboPaths.webPImage + ', ' + aboPaths.webPRetinaImage + ' 2x');
            sourceJpeg.setAttribute('srcset', aboPaths.jpgImage + ', ' + aboPaths.jpgRetinaImage + ' 2x');
        }
        else
        {
            sourceAvif.setAttribute('srcset', aboPaths.avifImage);
            sourceWebp.setAttribute('srcset', aboPaths.webPImage);
            sourceJpeg.setAttribute('srcset', aboPaths.jpgImage);
        }

        img.setAttribute('src', aboPaths.original);
        picture.append(sourceAvif);
        picture.append(sourceWebp);
        picture.append(sourceJpeg);
        picture.append(img);
        div.append(picture);

        return div;
    }

    /**
	 * Generates the product attribute part of the item list. 'variation' parameter can be an empty string:
	 * <ul>
	 *     <li>Bondage-Set</li>
	 *     <li>24931521001</li>
	 *     <li>Menge: 2 (je 23,92 €)</li>
	 * </ul>
	 * @param title {string}
	 * @param number {string}
	 * @param variation {string}
	 * @param quantity {string}
	 * @param price {string}
	 * @returns {HTMLUListElement}
	 */
    createProductAttributesElement(title, number, variation, quantity, price)
    {
        let ul = document.createElement('ul');

        let liTitle = document.createElement('li');
        liTitle.classList.add('js-basket-onsite__basket-item-list__title');

        liTitle.textContent = title;

        ul.append(liTitle);

        let liNumber = document.createElement('li');
        liNumber.classList.add('js-basket-onsite__basket-item-list__productNumber');

        liNumber.textContent = number;

        ul.append(liNumber);

        if (variation !== '')
        {
            let liVariation = document.createElement('li');
            liVariation.classList.add('js-basket-onsite__basket-item-list__variation');

            liVariation.textContent = variation;

            ul.append(liVariation);
        }

        let liQuantityPrice = document.createElement('li');
        liQuantityPrice.classList.add('js-basket-onsite__basket-item-list__quantityPrice');

        liQuantityPrice.textContent
			= this.quantityText + ' ' + quantity + ' (' + this.quantityPrefixText + ' ' + price + ')';

        ul.append(liQuantityPrice);

        return ul;
    }

    /**
	 * Generates the subtotal part of the item list.
	 * <div>
	 *     <p>47,84 €</p>
	 * </div>
	 * @param subTotal {string}
	 * @returns {HTMLDivElement}
	 */
    createSubTotalElement(subTotal)
    {
        let div = document.createElement('div');

        let p = document.createElement('p');
        p.classList.add('js-basket-onsite__basket-item-list__price');

        p.textContent = subTotal;

        div.append(p);

        return div;
    }
}

let basketOnsite = new BasketOnsite();

basketOnsite.init();
